<script setup lang="ts">
import type { CategorySlice } from '@/lib/charts/types'
import { VisDonut, VisSingleContainer } from '@unovis/vue'

withDefaults(defineProps<{
  slices: CategorySlice[]
  centralLabel?: string
  centralSubLabel?: string
  size?: number
}>(), { size: 180 })

const value = (slice: CategorySlice) => slice.value
const color = (slice: CategorySlice) => slice.color
</script>

<template>
  <!-- Explicit width keeps the SVG inside its box so it can't bleed over a
       neighbouring column. -->
  <div class="shrink-0 overflow-hidden" :style="{ width: `${size}px`, height: `${size}px` }">
    <VisSingleContainer :data="slices" :height="size" :width="size">
      <VisDonut
        :value="value"
        :color="color"
        :arc-width="Math.round(size * 0.16)"
        :central-label="centralLabel"
        :central-sub-label="centralSubLabel"
      />
    </VisSingleContainer>
  </div>
</template>
